/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaypalUpdateRequest
 */
export interface PaypalUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof PaypalUpdateRequest
     */
    token?: string;
}

/**
 * Check if a given object implements the PaypalUpdateRequest interface.
 */
export function instanceOfPaypalUpdateRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PaypalUpdateRequestFromJSON(json: any): PaypalUpdateRequest {
    return PaypalUpdateRequestFromJSONTyped(json, false);
}

export function PaypalUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaypalUpdateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': !exists(json, 'token') ? undefined : json['token'],
    };
}

export function PaypalUpdateRequestToJSON(value?: PaypalUpdateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': value.token,
    };
}

